import { FormInputSelect } from 'camino-react'
import React from 'react'
import { find } from 'lodash'

const Priority = ({ editedItem, priorities }) => {
  const priorityOptions = priorities.map(
    ({ id: value, name: label }) => ({ label, value })
  )

  const currentPriority = () => (
    find(priorityOptions, ({ value: editedItem.priority }))
  )

  const handlePriority = (priority) => (
    editedItem.updateOptionValue('priority', priority)
  )

  return (
    <FormInputSelect
      placeholder="Priority"
      value={currentPriority()}
      options={priorityOptions}
      onValue={value => handlePriority(value)}
    />
  )
}

export default Priority
